import { LeadActions } from "@/components/LeadActions";
import { SectionHeading } from "@/components/SectionHeading";
import { Card, CardContent } from "@/components/ui/card";
import { contactDetails } from "@/data/siteContent";

export default function AboutPage({ content }) {
  const isHindi = content.locale === "hi";
  const aboutHighlights = Array.isArray(content?.aboutPage?.highlights) ? content.aboutPage.highlights : [];
  const whyChooseUs = Array.isArray(content?.whyChooseUs) ? content.whyChooseUs : [];

  return (
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
      <SectionHeading eyebrow={isHindi ? "Sharda Agrotech के बारे में" : "About Sharda Agrotech"} title={content.aboutPage.title} description={content.aboutPage.description} />
      <div className="mt-8 grid gap-4 md:grid-cols-3">
        {aboutHighlights.map((item, index) => (
          <div key={item} className="rounded-[24px] border border-primary/10 bg-primary/5 px-5 py-5 text-sm font-semibold text-primary" data-testid={`about-page-highlight-${index + 1}`}>
            {item}
          </div>
        ))}
      </div>
      <div className="mt-10 grid gap-8 lg:grid-cols-[1fr_1fr]">
        <Card className="rounded-[32px] border-stone-200 bg-white shadow-sm">
          <CardContent className="space-y-6 p-8">
            <h2 className="font-heading text-3xl font-semibold text-stone-900" data-testid="about-page-company-title">
              {content.about.title}
            </h2>
            <p className="text-sm leading-7 text-stone-600" data-testid="about-page-company-intro">
              {content.about.intro}
            </p>
            <p className="text-sm leading-7 text-stone-600" data-testid="about-page-company-supporting">
              {content.about.supporting}
            </p>
          </CardContent>
        </Card>

        <Card className="rounded-[32px] border-primary/10 bg-primary text-white shadow-2xl shadow-emerald-300/25">
          <CardContent className="space-y-5 p-8">
            <p className="text-xs font-semibold uppercase tracking-[0.24em] text-emerald-100" data-testid="about-page-founder-eyebrow">
              {isHindi ? "संस्थापक" : "Founder"}
            </p>
            <h2 className="font-heading text-3xl font-semibold" data-testid="about-page-founder-name">
              {content.founder.name}
            </h2>
            <p className="text-sm font-semibold text-emerald-100" data-testid="about-page-founder-title">
              {content.founder.title}
            </p>
            <p className="text-sm leading-7 text-emerald-50" data-testid="about-page-founder-description">
              {content.founder.description}
            </p>
          </CardContent>
        </Card>
      </div>

      <div className="mt-8 grid gap-6 lg:grid-cols-2">
        <Card className="rounded-[28px] border-stone-200 bg-stone-50">
          <CardContent className="space-y-4 p-8">
            <p className="text-xs font-semibold uppercase tracking-[0.24em] text-stone-400" data-testid="about-page-mission-title">
              {isHindi ? "मिशन" : "Mission"}
            </p>
            <p className="text-sm leading-7 text-stone-600" data-testid="about-page-mission-text">
              {content.mission}
            </p>
          </CardContent>
        </Card>
        <Card className="rounded-[28px] border-stone-200 bg-stone-50">
          <CardContent className="space-y-4 p-8">
            <p className="text-xs font-semibold uppercase tracking-[0.24em] text-stone-400" data-testid="about-page-vision-title">
              {isHindi ? "विजन" : "Vision"}
            </p>
            <p className="text-sm leading-7 text-stone-600" data-testid="about-page-vision-text">
              {content.vision}
            </p>
          </CardContent>
        </Card>
      </div>

      <div className="mt-8 grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
        {whyChooseUs.map((item, index) => (
          <div key={item} className="rounded-[24px] border border-primary/10 bg-primary/5 px-5 py-5 text-sm font-semibold text-primary" data-testid={`about-page-trust-item-${index + 1}`}>
            {item}
          </div>
        ))}
      </div>

      <LeadActions labels={content.ctas} contact={contactDetails} prefix="about-page" className="mt-10" />
    </div>
  );
}